module.exports = __webpack_public_path__ + "static/media/preAuth.3b66fc51.png";